import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { useSiteSettings } from '../../context/SiteSettingsContext';

function parseJSON(str, fallback) {
  try { return JSON.parse(str); } catch { return fallback; }
}

const DEFAULT_LINKS = {
  Platform: [
    { label: 'Creator Marketplace', path: '/creators' },
    { label: 'Case Studies',        path: '/case-studies' },
    { label: 'Services',            path: '/services' },
    { label: 'For Brands',          path: '/for-brands' },
  ],
  Company: [
    { label: 'About Us',        path: '/about' },
    { label: 'Join as Creator', path: '/join-as-creator' },
    { label: 'Contact',         path: '/contact' },
  ],
};

export default function Footer() {
  const { settings } = useSiteSettings();

  const socialLinks = parseJSON(settings.footer_social_links, [
    { label: 'LinkedIn',    url: '#' },
    { label: 'Instagram',   url: '#' },
    { label: 'Twitter / X', url: '#' },
    { label: 'YouTube',     url: '#' },
  ]);

  const trustBadges = parseJSON(settings.footer_trust_badges, [
    '🔒 Brand Safe',
    '✅ Verified Creators',
    '📊 Data Driven',
  ]);

  const footerTagline = settings.footer_tagline || 'A creator deal agency connecting brands with top YouTube creators. We handle the deals — you own the growth.';
  const footerCta     = settings.footer_cta_text   || 'Start a Campaign →';
  const copyrightYear = settings.footer_copyright_year || new Date().getFullYear();
  const companyName   = settings.company_name || 'Lunivus';

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <img
              src={settings.logo_url_footer || 'https://image2url.com/r2/default/images/1775433225118-8a5b704a-de8f-4ced-8bc5-74286adc664f.png'}
              alt={companyName}
              width={settings.logo_width || '220'}
            />
          </Link>
          <p>{footerTagline}</p>
          <div className={styles.trust}>
            {trustBadges.map((badge, i) => <span key={i}>{badge}</span>)}
          </div>
        </div>

        {Object.entries(DEFAULT_LINKS).map(([section, items]) => (
          <div key={section} className={styles.col}>
            <h5>{section}</h5>
            <ul>
              {items.map(item => (
                <li key={item.label}><Link to={item.path}>{item.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}

        {/* Social Links column */}
        {socialLinks.length > 0 && (
          <div className={styles.col}>
            <h5>{settings.footer_connect_title || 'Connect'}</h5>
            <ul>
              {socialLinks.map(s => (
                <li key={s.label}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer">{s.label}</a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={styles.col}>
          <h5>{settings.footer_contact_title || 'Get In Touch'}</h5>
          <div className={styles.contactInfo}>
            <a href={`mailto:${settings.company_email || 'hello@lunivus.com'}`}>{settings.company_email || 'hello@lunivus.com'}</a>
            {settings.whatsapp_number && (
              <a href={`https://wa.me/${settings.whatsapp_number}`} target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
            )}
          </div>
          <Link to="/contact" className={styles.footerCta}>{footerCta}</Link>
        </div>
      </div>
      <div className={styles.bottom}>
        <p>© {copyrightYear} {companyName}. {settings.footer_rights_text || 'All rights reserved.'}</p>
        <div className={styles.legal}>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </footer>
  );
}
